import { createFileRoute } from "@tanstack/react-router";
import { AdoptionWizardPage } from "@charphq/ui/components/layout/pages/AdoptionWizardPage";

export const Route = createFileRoute("/deployments_/$deploymentId_/adopt")({
  component: AdoptionWizardComponent,
});

function AdoptionWizardComponent() {
  const { deploymentId } = Route.useParams();
  return <AdoptionWizardPage deploymentId={deploymentId} />;
}
